import { addTranslation } from '../../_helpers/Translate';
addTranslation({
  ru: {
    error_window_number_tab:'Не разрешается открывать больше 26 вкладок'
  },
  kk: {
    error_window_number_tab:"26 беттен артық ашуға рұқсат етілмейді"
  }
});
